export const MAP_CENTER = { lat: 20.80746, lng: 20.4796 };
export const MIN_ZOOM = 2;
export const COUNTRY_ZOOM = 4;
export const MAP_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
export const MAP_ATTRIBUTION = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
